import { render } from "./widget-bulk-download-client.vue?vue&type=template&id=14151582&scoped=true&ts=true"
import script from "./widget-bulk-download-client.vue?vue&type=script&lang=ts"
export * from "./widget-bulk-download-client.vue?vue&type=script&lang=ts"

import "./widget-bulk-download-client.vue?vue&type=style&index=0&id=14151582&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14151582"]])

export default __exports__